<template>
  <Modal
    :id="'cmp-distribution-suppliers-add_catalogue_form'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('category')}}</template>

    <template slot="body">
      <div class="contact-search">
        <InputField
          :id="'contact_search'"
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'around',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          :id="'product_type_id'"
          :options="product_typesTV"
          class="m2"
          :selected="
            product_typesTV.find((b) => b.value == searchModel.product_type_id)
          "
          :placeholder="$t('category')"
          box
          @selectedChange="(b) => onDropdownChange('product_type_id', b)"
          style="height: 40px; width: 250px"
          :listHeight="200"
          deselect
          :showValidationIcons="false"
        ></Dropdown>
      </div>

      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
              'margin-right': hRowMarginRight,
            }"
          >
            <th style="max-width: 35px" class="dt-table2--column"></th>
            <th class="dt-table2--column">{{$t('category_no')}}</th>
            <th class="dt-table2--column">{{$t('artist')}}</th>
            <th class="dt-table2--column">{{$t('title')}}</th>
            <th class="dt-table2--column">{{$t('format')}}</th>
          </tr>
        </thead>
        <tbody class="dt-table2--body">
          <tr
            class="dt-table2--row"
            v-for="product in productList"
            :key="product.product_id"
            @click="(e) => onClickRow(e, product)"
          >
            <td
              style="max-width: 35px"
              class="dt-table2--column checkbox-column"
            >
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  @click.stop="(e) => onCheckboxChange(e, product)"
                  name="product_id"
                  id="product_id"
                  :checked="selecteditems.has('product_id')"
                />
                <div class="checkmark"></div>
              </div>
            </td>
            <td class="dt-table2--column">
              {{ product["catalog_no"] }}
            </td>
            <td class="dt-table2--column">{{ product["release_artist"] }}</td>
            <td class="dt-table2--column">{{ product["release_title"] }}</td>
            <td class="dt-table2--column">{{ product["format_name"] }}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>
  
  <script>
import Modal from "@dtplugins/modal/modal";
import { Subject } from "rxjs";
import InputField from "../../../../plugins/text-field/input-field";
import { subscribeSubject } from "../../../../utility";
import { SuppliersService } from "../../services/suppliers.service";
import SearchList from "@dtplugins/search-list/search-list";
import { addRemoveSet } from "../../../../utility";
import { createTV } from "../../../../models/text-value.model";
export default {
  props: ["selectedSupplierDetails"],
  components: {
    Modal,
    InputField,
    SearchList,
  },

  data: function () {
    return {
      searchString: "",
      product_types: [],
      productList: [],
      searchSubject$: new Subject(),
      searchSize: "single",
      selecteditems: new Set(),
      searchModel: { supplier_id: "", str: "", product_type_id: "" },
    };
  },
  mounted: function () {
    SuppliersService.fetchProductTypes().then((res) => {
      this.product_types = res.data.product_types;
    });
    subscribeSubject(this, this.searchSubject$, (searchString) => {
      SuppliersService.searchProducts({
        str: searchString,
        product_type_id: this.searchModel.product_type_id,
        supplier_id: this.supplier_id,
      }).then((res) => {
        this.productList = res.data.products;
      });
    });
  },
  computed: {
    product_typesTV: function () {
      return createTV(
        this.product_types,
        "product_type_name",
        "product_type_id"
      );
    },
    supplier_id: function () {
      return this.$route.params.supplier_id;
    },
    searchStringLength: function () {
      if (this.searchString.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hRowMarginRight: function () {
      if (this.productList.length > 380 / 28) {
        return "28px";
      }
    },
  },
  methods: {
    updateSet: function (operation = true, set = new Set(), selected) {
      if (selected) {
        return addRemoveSet(operation, set, selected);
      } else {
        return set;
      }
    },
    onSearchInputKeyup: function (e) {
      this.searchString = e.target.value;
      this.searchSubject$.next(this.searchString);
    },
    onDropdownChange: function (name, value) {
      this.searchModel.product_type_id = value.value;
      SuppliersService.searchProducts({
        str: this.searchString,
        product_type_id: this.searchModel.product_type_id,
        supplier_id: this.supplier_id,
      }).then((res) => {
        this.productList = res.data.products;
      });
    },
    onClickRow: function (event, item) {
      console.log("item", item);
      this.selecteditems = this.updateSet(
        "toggle",
        this.selecteditems,
        item.product_id
      );
    },
    onCheckboxChange: function (event, item) {
      const value = event.target.checked;
      this.selecteditems = addRemoveSet(
        event.target.checked,
        this.selecteditems,
        item.product_id
      );

      console.log("WWWW", item.product_id, value);
    },

    async onOkClick() {
      const product_ids = Array.from(this.selecteditems).join(",");
      const res = await SuppliersService.addProducts({
        supplier_id: this.supplier_id,
        product_ids: product_ids,
      });
      if (res.data) {
        const res = await SuppliersService.loadSupplierProducts({
          supplier_id: this.supplier_id,
        });

        this.$emit("added", res.data.products);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>
  
  <style lang="scss" >
.cmp-distribution-suppliers-add_catalogue_form {
  .contact-search {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 10px;
    .input-field-container {
      margin-right: 20px;
      height: 40px;
    }
  }
  th.dt-table2--column {
    padding:0px 15px;
  }
 td.dt-table2--column {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0px 12px;
  
  }
}
</style>
  